import { NestedHome, NestedUser, SellerIntentType } from "@habity/types";
import { isSellerClaimed } from "./homes/general";
import { ROUTES } from "@habity/constants";

export const isHomeOwner = (home: NestedHome, user?: NestedUser | null) => {
  const { id } = home;
  const { homes } = user || {};
  return (
    homes && homes.length > 0 && homes.find((h: NestedHome) => h.id === id)
  );
};

export const isUserClaimedHome = (home: NestedHome, user?: NestedUser | null) => {
  return isHomeOwner(home, user) && isSellerClaimed(home);
}

export const getSellPath = (
  brokerId?: number, 
  intent?: SellerIntentType,
  options?: { municipalityId?: number; areaId?: number; homeId?: number }
) => {
  const url = new URLSearchParams();
  // Build path with intent as subpath: /sell/meeting, /sell/valuation, etc.
  const path = intent ? `${ROUTES.SELL}/${intent}` : ROUTES.SELL;
  
  if (brokerId) url.set('broker', brokerId.toString());
  if (options?.municipalityId) url.set('municipalityId', options.municipalityId.toString());
  if (options?.areaId) url.set('areaId', options.areaId.toString());
  if (options?.homeId) url.set('homeId', options.homeId.toString());
  
  return path + (url.toString() ? `?${url.toString()}` : '');
}